import React from 'react';
import { Button, Grid } from 'semantic-ui-react';
import { Filter, Main } from '../../../containers/';
import 'PageStyles/styleguide/index.less';

const breadcrumbs = [{ title: 'Style Guide' }, { title: 'Buttons' }];

export const Buttons = props => (
  <div className="style-guide--page-buttons">
    <Filter title="Buttons" breadcrumbs={breadcrumbs} />
    <Main>
      <Grid>
        <Grid.Row className="style-guide--group">
          <Grid.Column>
            <label>Primary and Secondary Buttons</label>
            <Button primary>Primary Button</Button>
            <Button secondary>Secondary Button</Button>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row className="style-guide--group">
          <Grid.Column>
            <label>Positive and Negative Buttons</label>
            <Button positive>Positive Button</Button>
            <Button negative>Negative Button</Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Main>
  </div>
);



// WEBPACK FOOTER //
// ./src/pages/styleguide/components/Buttons.js